import Wallet from "./Wallet"

const PatientWallet = () => {
  return (
    <div className="flex justify-center items-center h-[91vh] w-[100%]">
      <Wallet />
    </div>
  )
}

export default PatientWallet
